import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSkeletonNewTree = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 68.04,
			d: "M1575.8 1848.83v107.24c0 19.06-13.79 34.54-30.78 34.54h-95.56c-16.99 0-30.79-15.48-30.79-34.54v-107.24c0-19.07 13.8-34.55 30.79-34.55h95.56c16.99 0 30.78 15.48 30.78 34.55",
			transform: "matrix(1.1173 0 0 .99563 -1466.712 -1681.256)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 68.04,
			d: "M1575.8 1848.83v107.24c0 19.06-13.79 34.54-30.78 34.54h-95.56c-16.99 0-30.79-15.48-30.79-34.54v-107.24c0-19.07 13.8-34.55 30.79-34.55h95.56c16.99 0 30.78 15.48 30.78 34.55",
			transform: "matrix(1.1173 0 0 .99563 -948.733 -1681.256)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 68.04,
			d: "M1575.8 1848.83v107.24c0 19.06-13.79 34.54-30.78 34.54h-95.56c-16.99 0-30.79-15.48-30.79-34.54v-107.24c0-19.07 13.8-34.55 30.79-34.55h95.56c16.99 0 30.78 15.48 30.78 34.55",
			transform: "matrix(1.1173 0 0 .99563 -1209.184 -1308.939)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.998388,
			d: "M293.921 212.876h342.42M259.528 300.65 375.89 495.268"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72,
			d: "M784.69 622.56v320M624.7 782.56h320"
		})
	]
});
export default SvgIconSkeletonNewTree;
